import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { getFavorites } from '../lib/api';
import ListingCard from '../components/ListingCard';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Heart, Loader2, Home } from 'lucide-react';

const FavoritesPage = () => {
  const { language } = useLanguage();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    try {
      const res = await getFavorites();
      setFavorites(res.data);
    } catch (error) {
      console.error('Error loading favorites:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background py-8">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-3 mb-2">
            <Heart className="h-8 w-8 text-primary fill-primary" />
            <h1 className="font-heading text-3xl md:text-4xl font-bold" data-testid="favorites-title">
              {language === 'fr' ? 'Mes Favoris' : 'My Favorites'}
            </h1>
          </div>
          <p className="text-muted-foreground">
            {language === 'fr'
              ? `${favorites.length} logement${favorites.length > 1 ? 's' : ''} sauvegardé${favorites.length > 1 ? 's' : ''}`
              : `${favorites.length} saved listing${favorites.length > 1 ? 's' : ''}`}
          </p>
        </div>

        {/* Content */}
        {favorites.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {favorites.map((listing) => (
              <ListingCard key={listing.listing_id} listing={listing} />
            ))}
          </div>
        ) : (
          <Card className="max-w-md mx-auto">
            <CardContent className="pt-8 pb-8 text-center">
              <Heart className="h-16 w-16 mx-auto mb-4 text-muted-foreground/30" />
              <h3 className="font-heading text-xl font-semibold mb-2">
                {language === 'fr' ? 'Aucun favori' : 'No favorites yet'}
              </h3>
              <p className="text-muted-foreground mb-6">
                {language === 'fr'
                  ? 'Parcourez nos logements et ajoutez vos préférés en cliquant sur le cœur.'
                  : 'Browse our listings and add your favorites by clicking the heart icon.'}
              </p>
              <Link to="/listings">
                <Button data-testid="browse-listings-btn">
                  <Home className="mr-2 h-4 w-4" />
                  {language === 'fr' ? 'Parcourir les logements' : 'Browse listings'}
                </Button>
              </Link>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
